import { render, staticRenderFns } from "./NftDetails.vue?vue&type=template&id=78eef7f5&scoped=true&"
import script from "./NftDetails.vue?vue&type=script&lang=js&"
export * from "./NftDetails.vue?vue&type=script&lang=js&"
import style0 from "./NftDetails.vue?vue&type=style&index=0&id=78eef7f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78eef7f5",
  null
  
)

export default component.exports